exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans|Quicksand:500,700&amp;subset=vietnamese);", ""]);

// module
exports.push([module.id, "body{font-family:Open Sans,sans-serif}", ""]);

// exports
